import React from "react";
import { Field } from "redux-form";
import * as normalizers from "common/normalizers";
import * as validations from "common/validations";
import InputPack from "components/InputPack";
import SelectPack from "components/SelectPack2";
import Tile from "components/Tile";
import TileBody from "components/TileBody";
import ActionLink from "components/ActionLink";

const SaltBlocksFieldArray = (props) => {
    const { fields, saltBlockTypes } = props;

    const _add = (e) => {
        e.preventDefault();
        fields.push({});
    };

    const _remove = (index) => (e) => {
        e.preventDefault();
        fields.remove(index);
    };

    return (
        <Tile
            title="Salt block applications"
            actions={
                <span id="add-salt-block-link" onClick={_add} className="IconLink--arrow-plus u-link">
                    Add salt block application
                </span>
            }
            tertiary
        >
            <TileBody>
                <div className="Table u-mt-md">
                    <table>
                        <thead>
                            <tr>
                                <th data-width="md-40 xl-40">Salt block type</th>
                                <th data-width="md-20 xl-20">Number of blocks per year</th>
                                {fields.length > 0 && <th className="th--shrink">&nbsp;</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {fields.length === 0 && (
                                <tr>
                                    <td colSpan="3">
                                        <div className="Tile-body">
                                            <div className="Tile-body-message">
                                                <p className="h4 u-mt-0">You do not have any salt block applications</p>
                                                <ActionLink id="add-salt-block-button" onClick={_add} className="IconLink--arrow-plus Button Button--sm u-mt-md">
                                                    <span>Add salt block application</span>
                                                </ActionLink>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            )}
                            {fields.length > 0 &&
                                fields.map((saltBlock, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>
                                                <Field name={`${saltBlock}.type`} noLabel={true} placeholder="Select type" options={saltBlockTypes} required={true} validate={[validations.required]} component={SelectPack} />
                                            </td>
                                            <td>
                                                <Field name={`${saltBlock}.numberPerYear`} noLabel={true} placeholder="0" uom="number/yr" type="text" normalize={normalizers.integer} requiredLabel={true} component={InputPack} validate={[validations.required, validations.range(1, 10000)]} />
                                            </td>
                                            <td>
                                                <ActionLink id={`remove-salt-block-${index}`} className="IconLink--cross-circle" onClick={_remove(index)}>
                                                    <span></span>
                                                </ActionLink>
                                            </td>
                                        </tr>
                                    );
                                })}
                        </tbody>
                    </table>
                </div>
            </TileBody>
        </Tile>
    );
};

export default SaltBlocksFieldArray;
